import React, { ReactElement, useState } from 'react';
import KlaviyoManager from '../../Components/Klaviyo/KlaviyoManager';
import { validateEmail } from '../../utils/utils';
import KodanshaCheckBox from '../KodanshaUIKit/KodanshaCheckBox/KodanshaCheckBox';
import KodanshaEmail from '../KodanshaUIKit/KodanshaEmail/KodanshaEmail';
import './NewsLetterSignUpStrip.scss';

export default function NewsLetterSignUpStrip(): ReactElement {
    const [Email, setEmail] = useState('');
    const [isSubscribed, setSubscribed] = useState(false);

    const [NewsCheckBoxItems, setNewsCheckBoxItems] = useState([
        { title: 'MANGA NEWS', isChecked: false, listId: 'UvYEux' },
        { title: 'BOOK NEWS', isChecked: false, listId: 'SVrxRH' },
        { title: 'PRESS RELEASES', isChecked: false, listId: 'T9iiKn' },
        { title: 'RETAILER NEWS', isChecked: false, listId: 'RBmsjr' },
    ]);

    const onCheckBoxChange = (isChecked: boolean, index: number): void => {
        const tempCheckBoxItems = [...NewsCheckBoxItems];
        tempCheckBoxItems[index].isChecked = isChecked;
        setNewsCheckBoxItems([...tempCheckBoxItems]);
    };

    const saveChanges = async (): Promise<void> => {
        for (let i = 0; i < NewsCheckBoxItems.length; i++) {
            const item = NewsCheckBoxItems[i];
            if (item.isChecked) {
                await KlaviyoManager.AddEmailToList(item.listId, Email);
                setSubscribed(true);
            }
        }
    };

    return (
        <div className='news-letter-sign-up-strip'>
            <div className='news-letter-sign-up-strip-wrapper'>
                <div className='mailing-list titlebar'>
                    <div className='mailing-list-inner-wrapper-title'>
                        <div className='mailing-list-titlebar'>
                            <h2>Get the Latest News from Kodansha</h2>
                        </div>
                    </div>
                </div>
                <div className='mailing-list'>
                    <div className='mailing-list-inner-wrapper'>
                        <div className='mailing-list-options-email-container'>
                            <div className='mailing-list-options-email-wrapper'>
                                <div className='mailing-list-options'>
                                    <div className='acc-news-letter-checkbox-wrapper'>
                                        {NewsCheckBoxItems.map((item, index) => (
                                            <KodanshaCheckBox
                                                key={index}
                                                onChange={(isChecked): void => {
                                                    onCheckBoxChange(isChecked, index);
                                                }}
                                                checked={item.isChecked}
                                                label={item.title}
                                                ariaLabel={'Checkbox for ' + item.title + ' and it is ' + item.isChecked}
                                            />
                                        ))}
                                    </div>
                                </div>
                                <div className='auth-login-email-wrapper'>
                                    <p>Email Address</p>
                                    <KodanshaEmail
                                        placeHolder='youremail@domain.com'
                                        onChange={(value): void => {
                                            console.log('email is' + value);
                                            setEmail(value);
                                        }}
                                        onEnterPushed={saveChanges}
                                    />
                                </div>
                            </div>
                            {isSubscribed && <div className='subscribed-message'>
                                A verification email has been sent to your email address, please follow the steps in the email to confirm your subscription. Until you have verified your email, your email will not be considered subscribed.
                            </div>}
                        </div>
                        <div
                            className={`mailing-list-signup-button ${validateEmail(Email) && 'mailing-list-signup-button-active'} ${isSubscribed && 'mailing-list-signup-button-none'}`}
                            onClick={saveChanges}>
                            <span>SIGN UP</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
